let REACT_APP_API_URL = process.env.REACT_APP_API_URL;
if (!process.env.REACT_APP_API_URL) REACT_APP_API_URL = process.env.REACT_APP_API_DEV_URL;

export const getClients = async (page, filters) => {
  const token = localStorage.getItem("token");
  const branchesQuery = filters?.branches?.length > 0 ? `&${filters.branches.map(type => `branch[]=${type}`).join('&')}` : '';
  const curvesQuery = filters?.curves?.length > 0 ? `&${filters.curves.map(type => `curve[]=${type}`).join('&')}` : '';
  const orderQuery = () => {
    if(filters?.order) {
      const splittedQuery = filters?.order?.split("&");
      if(splittedQuery.length === 2) {
        return `&orderBy=${splittedQuery[0]}&order=${splittedQuery[1]}`
      }
    }
    return ''
  };
  
  const buildUrl = () => {
    const baseUrl = REACT_APP_API_URL + '/dashboard/leads';
    const pagination = page >= 0 ? `?page=${page}&size=10` : '';
    const order = orderQuery();
    const business = filters?.businessName ? `&businessName=${filters?.businessName}` : '';
    
    return `${baseUrl}${pagination}${order}${branchesQuery}${curvesQuery}${business}`;
  };
  
  const response = await fetch(buildUrl(), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
}

export const getAllClients = async () => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads?returnAll=true`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
}

export const getLead = async (username) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads/${username}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
}

export const createLead = async (leadInfo) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(leadInfo),
  });
  const data = await response.json();
  return data;
}

export const createContact = async (contactInfo) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads/contact`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(contactInfo),
  });
  const data = await response.json();
  return data;
}

export const editLead = async (id, leadInfo) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(leadInfo),
  });
  const data = await response.json();
  return data;
}

export const deleteLead = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
};

export const getCommercialHomeGraphs = async (startDate, endDate) => {
  const token = localStorage.getItem("token");
  const startDateQuery = startDate ? `?startDateMs=${startDate}` : '';
  const endDateQuery = endDate ? `&endDateMs=${endDate}` : '';
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads/home${startDateQuery}${endDateQuery}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
};

export const editContact = async (id, leadInfo) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads/contact/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(leadInfo),
  });
  const data = await response.json();
  return data;
}

export const deleteContact = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads/contact/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
};

export const createSimpleLead = async (project) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(project),
  });
  const data = await response.json();
  return data;
};

export const editLeadPhoto = async (edit) => {
  const formData = new FormData();
  Object.entries(edit).forEach(entry => {
    const isArray = Array.isArray(entry[1]);
    if (isArray) {
      entry[1].forEach((str, index) => {
        formData.append(`${entry[0]}[${index}]`, str);
      })
      return
    }
    formData.append(entry[0], entry[1]);
  });
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads/files`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: formData,
  });
  const data = await response.json();
  return data;
};

export const getLeadsFinancial = async (id, page, startDate, endDate) => {
  const token = localStorage.getItem("token");
  const startDateQuery = startDate ? `&startDateMs=${startDate}` : '';
  const endDateQuery = endDate ? `&endDateMs=${endDate}` : '';
/*  const branchesQuery = filters?.branches?.length > 0 ? `&${filters.branches.map(type => `branch[]=${type}`).join('&')}` : '';
  const curvesQuery = filters?.curves?.length > 0 ? `&${filters.curves.map(type => `curve[]=${type}`).join('&')}` : '';*/
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads/${id}/financial-entries${page >= 0 ? `?page=${page}&size=10${startDateQuery}${endDateQuery}` : ''}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
}

export const createLeadRelation = async (relationInfo) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads-relations`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(relationInfo),
  });
  const data = await response.json();
  return data;
};

export const getChildLeads = async (parentId) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads-relations/children/${parentId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
};

export const getParentLeads = async (childId) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads-relations/parents/${childId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
};

export const deleteLeadRelation = async (relationId) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/leads-relations/${relationId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  const data = await response.json();
  return data;
};